import React from 'react'
import { proxyStorageUrl } from '../../../lib/supabase'

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export const formatDateTime = (dateStr) => {
  const d = new Date(dateStr)
  return d.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const isImageUrl = (url) => {
  if (!url) return false
  const cleanUrl = url.split('?')[0].toLowerCase()
  return cleanUrl.endsWith('.jpg') || 
         cleanUrl.endsWith('.jpeg') || 
         cleanUrl.endsWith('.png') || 
         cleanUrl.endsWith('.gif') || 
         cleanUrl.endsWith('.webp') || 
         cleanUrl.endsWith('.heic') ||
         (url.includes('supabase') && (url.includes('/evidence/') || url.includes('/disputes/') || url.includes('/deductions/')))
}

export const renderEvidence = (rawUrl, setImagePreviewModal) => {
  if (!rawUrl) return null
  const urls = rawUrl.split('|')
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px' }}>
      {urls.map((url, idx) => {
        if (!url) return null
        const isImg = isImageUrl(url)
        const isVid = url.toLowerCase().includes('.mp4') || url.toLowerCase().includes('.mov')
        
        if (isImg) {
          return (
            <div 
              key={idx}
              style={{ cursor: 'pointer', display: 'inline-block' }}
              onClick={(e) => { e.stopPropagation(); setImagePreviewModal(proxyStorageUrl(url)); }}
            >
              <img src={proxyStorageUrl(url)} alt="Доказательство" style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px', border: '1px solid var(--border-color)', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }} />
            </div>
          )
        } else {
          return (
            <a 
              key={idx}
              href={proxyStorageUrl(url)} 
              target="_blank" 
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
              style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: '6px', 
                color: 'var(--wb-primary, #6b21a8)', 
                fontSize: '12px', 
                background: 'var(--surface-hover)', 
                padding: '6px 12px', 
                borderRadius: '6px', 
                border: '1px solid var(--border-color)', 
                textDecoration: 'none',
                fontWeight: 500,
                height: '32px'
              }}
            >
              <span>{isVid ? ' Видеодоказательство' : ' Ссылка на доказательство'}</span>
            </a>
          )
        }
      })}
    </div>
  )
}

export const formatMoney = (amount) => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(amount)
}

export const typeConfig = {
  bonus: { label: 'Премия', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>, color: 'var(--info)', bgColor: 'var(--info-bg)' },
  fine: { label: 'Штраф', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>, color: 'var(--danger)', bgColor: 'var(--danger-bg)' },
  salary: { label: 'Выплата ЗП', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>, color: 'var(--success)', bgColor: 'rgba(34,197,94,0.1)' },
  deduction_брак: { label: 'Брак', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>, color: '#ef4444', bgColor: 'rgba(239,68,68,0.1)' },
  deduction_подмена: { label: 'Подмена', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>, color: '#f97316', bgColor: 'rgba(249,115,22,0.1)' },
  deduction_зависшие: { label: 'Зависшие', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>, color: '#eab308', bgColor: 'rgba(234,179,8,0.1)' },
  deduction_другое: { label: 'Удержание', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg>, color: '#6b7280', bgColor: 'rgba(107,114,128,0.1)' },
}

export const startOfYear = () => {
  const d = new Date()
  return `${d.getFullYear()}-01-01`
}

export const today = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export const firstDayOfMonth = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
}

export const lastDayOfMonth = () => {
  const d = new Date()
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(last).padStart(2, '0')}`
}

export const firstHalfStart = () => firstDayOfMonth()

export const firstHalfEnd = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-15`
}

export const secondHalfStart = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-16`
}

export const clearLegacyPaymentCache = () => {
  try {
    Object.keys(localStorage).forEach(k => {
      if (k.startsWith('cache_payments_')) {
        localStorage.removeItem(k)
      }
    })
  } catch {}
}

export const getCachedState = (key, defaultVal) => {
  clearLegacyPaymentCache()
  return defaultVal
}

export const setCachedState = (key, val) => {
  clearLegacyPaymentCache()
}

export const getNearestOwedPeriod = (config = null) => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() // 0-11
  const date = now.getDate()
  const pad = (n) => String(n).padStart(2, '0')

  const rawFreq = config?.payoutFrequency || 'bi_monthly'
  const freq = rawFreq === 'biweekly' ? 'bi_monthly' : rawFreq

  if (freq === 'daily') {
    const todayStr = `${year}-${pad(month + 1)}-${pad(date)}`
    return { start: todayStr, end: todayStr }
  }

  if (freq === 'weekly') {
    const currentDay = now.getDay()
    const distanceToMonday = currentDay === 0 ? 6 : currentDay - 1
    const monday = new Date(now)
    monday.setDate(now.getDate() - distanceToMonday)
    const sunday = new Date(monday)
    sunday.setDate(monday.getDate() + 6)
    return {
      start: `${monday.getFullYear()}-${pad(monday.getMonth() + 1)}-${pad(monday.getDate())}`,
      end: `${sunday.getFullYear()}-${pad(sunday.getMonth() + 1)}-${pad(sunday.getDate())}`
    }
  }

  if (freq === 'monthly') {
    const lastDay = new Date(year, month + 1, 0).getDate()
    return {
      start: `${year}-${pad(month + 1)}-01`,
      end: `${year}-${pad(month + 1)}-${pad(lastDay)}`
    }
  }

  if (freq === 'shifts') {
    // При расчёте по сменам показываем текущий месяц
    const lastDay = new Date(year, month + 1, 0).getDate()
    return {
      start: `${year}-${pad(month + 1)}-01`,
      end: `${year}-${pad(month + 1)}-${pad(lastDay)}`
    }
  }

  if (date <= 15) {
    const prevMonth = new Date(year, month - 1, 1)
    const prevYear = prevMonth.getFullYear()
    const prevMonthIdx = prevMonth.getMonth()
    const lastDayOfPrevMonth = new Date(prevYear, prevMonthIdx + 1, 0).getDate()
    
    return {
      start: `${prevYear}-${pad(prevMonthIdx + 1)}-16`,
      end: `${prevYear}-${pad(prevMonthIdx + 1)}-${pad(lastDayOfPrevMonth)}`
    }
  } else {
    return {
      start: `${year}-${pad(month + 1)}-01`,
      end: `${year}-${pad(month + 1)}-15`
    }
  }
}
